/** The Pack Seed Re-Printing list: slips at this plant by status. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { SlipListPage } from "@/features/processing/components/slip-list-page";

const search = z.object({
  tab: z
    .enum(["draft", "previewed", "submitted", "cancelled"])
    .default("draft"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/packaging/pack-reprint/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <SlipListPage
      form="revalidate"
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
